<template>
    <basic-layout>
        <teleport to="#top-bar-teleport">
            <div class="flex items-center" v-if="title">
                <h1 class="text-xl font-medium grow">
                    {{ title }}
                </h1>
                <slot name="buttons">
                    <div class="flex gap-4">
                        <slot name="additional_buttons"></slot>
                    </div>
                </slot>
            </div>
        </teleport>
        <div class="md:border md:px-4 md:bg-white md:dark:bg-black dark:border-neutral-700 rounded-xl w-full">
            <slot></slot>
        </div>
    </basic-layout>
</template>
<script setup>
import BasicLayout from './BasicLayout.vue';
import { defineProps } from "vue";
import Button from "primevue/button";
defineProps({
    title: String,
    addEnabled: {
        default: true,
        type: Boolean
    }
})
</script>
<style scoped lang="scss">
</style>
